export interface ConfirmationDialogData {
  title: string;
  message: string;
  confirmButtonLabel?: string;
  cancelButtonLabel?: string;
  buttonLabel?: string;
  buttonColor?: string;
  hideCancelButton?: boolean;
  icon?: string;
}
